export function publishRightPanelWidth(element: HTMLElement): () => void
{
    const observer = new ResizeObserver(([entry]) =>
        document.documentElement.style.setProperty("--right-panel-width", `${entry.contentRect.width}px`));
    observer.observe(element);
    return () =>
    {
        observer.disconnect();
        document.documentElement.style.setProperty("--right-panel-width", "0px");
    };
}
